// AUTO-GENERATED by .bin/generateRetiredBlogSlugs.js — do not edit by hand.
// Blog posts that are still published in Prismic but whose URLs 301 elsewhere
// (see next-redirects.js). Excluded from listings so we never link to a URL that
// redirects away as soon as it is loaded directly.
export const retiredBlogSlugs: string[] = [
  '5-benefits-of-a-virtual-office-for-freelancers',
  '7-main-virtual-team-challenges-7-great-solutions',
  '7-pro-features-of-virtual-office',
  '7-steps-for-shutting-down-a-virtual-office',
  '7-ways-increase-productivity-virtual-office',
  'cheapest-registered-office-address-for-small-business',
  'common-failures-in-starting-up-a-business-and-tips',
  'ethical-and-legal-implications-of-the-use-of-virtual-offices',
  'gonecardless',
  'how-to-file-a-company-confirmation-statement',
  'how-to-get-certificate-of-incorporation-in-2022',
  'how-to-search-for-uk-registered-companies',
  'how-to-start-ecommerce-business-in-the-uk',
  'hoxton-mix-directors-invited-to-reception-at-buckingham-palace',
  'rent-a-virtual-office-today',
  'set-up-a-company-online',
  'the-scope-of-an-online-coaching-business',
  'top-5-questions-ask-choosing-virtual-office-service',
  'virtual-mailbox',
  'virtual-mailing-addresses',
  'virtual-office-space-for-rent--the-best-virtual-office',
  'what-is-business-address-rental',
]
